import React from 'react';

export const SidebarContext = React.createContext<boolean>(false);
export const SidebarRefContext = React.createContext<React.RefObject<HTMLDivElement | null> | undefined>(undefined);
